





































































































































































import {
  Component,
  Vue,
  Prop,
  Watch
} from "vue-property-decorator";
import bcdata from "../assets/data";
import CardItem from "@/components/CardItem.vue";
import DetailCard from "@/components/DetailCard.vue";
import SimpleDropdown from "@/components/SimpleDropdown.vue";
import RiskItem from "@/components/RiskItem.vue";
import NavMenu from '@/components/NavMenu.vue';
import {
  library
} from '@fortawesome/fontawesome-svg-core';
import {
  faThumbsUp,
  faThumbsDown,
  faExclamationTriangle,
  faCarrot,
  faTimes,
  faBoxes,
  faUsers,
  faCubes,
  faBriefcase,
  faMoneyBill,
  faHandshake,
  faHandsHelping,
  faBuilding,
  faAmericanSignLanguageInterpreting,
  faExchangeAlt,
  faLink,
  faPoll,
  faBook,
  faCaretDown,
  faPlusSquare,
  faCaretRight,
  faQuoteRight,
  faLongArrowAltRight,
} from '@fortawesome/free-solid-svg-icons';
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';
import {
  dom
} from '@fortawesome/fontawesome-svg-core';
import {
  ecoCategoryOptions,
  archCategoryOptions,
  Selection,
  Coin
} from '@/model/data-model';
import VueQrcode from '@chenfengyuan/vue-qrcode';

type DisplayMode = "standard" | "simple" | "arch" | "report";

@Component({
  components: {
    CardItem,
    DetailCard,
    SimpleDropdown,
    RiskItem,
    NavMenu,
    'font-awesome-icon': FontAwesomeIcon,
    [VueQrcode.name]: VueQrcode,
  }
})
export default class Guide extends Vue {
  @Prop() private msg!: string;
  private displayMode: DisplayMode = "standard";
  private editMode = false;
  private archData = bcdata.archData;
  private archList = bcdata.archList;
  private typeData = bcdata.typeData;
  private ecoData = bcdata.ecoData;
  private riskData = bcdata.riskData;
  private selections: Selection = {
    currency: "frommine_deflation",
    ledger: "chain",
    hash: "sha2",
    signature: "ecdsa",
    contracts: "limitstackvm",
    permission: "permissioned",
    api: "rpc",
    consensus: "pow_sha2",
    incentive: ["mine", "fee", "profitsharing"],
    governance: ["voting_code", "foundation", "voting_community"],
    dapp: ["oracle", "central_exchange", "distributed_exchange"]
  };
  private modes = bcdata.modes;
  simCoins: Coin[] = [];
  private urlParams = '';

  beforeMount() {
    library.add(
      faThumbsUp, faThumbsDown, faExclamationTriangle, faCarrot, faTimes, faBoxes, faUsers,
      faCubes, faBriefcase, faMoneyBill, faHandshake, faHandsHelping,
      faBuilding, faAmericanSignLanguageInterpreting, faExchangeAlt, faLink, faPoll, faBook,
      faCaretDown, faPlusSquare, faCaretRight, faLongArrowAltRight);
    dom.watch(); // This will kick of the initial replacement of i to svg tags and configure a MutationObserver
    this.parseQuery();
    this.calcSimilarity();
  };

  mounted() {
    (window as any).getSimilarity = () => {
      return {
        name: this.simCoins[0].name,
        desc: this.simCoins[0].desc,
        similarity: this.simCoins[0].similarity,
        url: 'http://b.uchaindb.com/#' + this.urlParams,
      };
    }
  }

  @Watch("$route")
  routeChanged(to: any, from: any) {
    // console.log("nav", to, from);
  }

  private addEcoItem(category: ecoCategoryOptions, item: string) {
    if (this.selections[category].findIndex(_ => _ == item) == -1) {
      this.selections[category].push(item);
      this.onDataChanged();
    }
  }

  private removeEcoItem(category: ecoCategoryOptions, idx: number) {
    this.selections[category].splice(idx, 1);
    this.onDataChanged();
  }

  private changeArchItem(category: archCategoryOptions, item: string) {
    // because ts complain: Type 'any' is not assignable to type 'never'
    // so change the statements
    // this.selections[category] = item as any;
    let obj: any = {};
    obj[category] = item;
    Object.assign(this.selections, obj);
    this.onDataChanged();
  }

  private changeDisplayMode(mode: DisplayMode) {
    this.displayMode = mode;
    this.onDataChanged();
  }

  private onDataChanged() {
    this.calcSimilarity();
    this.setQuery();
  }

  private calcSimilarity() {
    let coins = bcdata.coins.map(c => {
      let similarity = 0;
      let differences: {
        category: string,
        coinSelect: string,
        userSelect: string,
      } [] = [];
      const simitems: archCategoryOptions[] = [
        'currency', 'ledger', 'hash', 'signature', 'contracts', 'permission', 'api', 'consensus'
      ];
      const eachPercent = 1 / simitems.length;

      simitems.forEach(simitem => {
        if (this.selections[simitem] == c.char[simitem]) {
          similarity += eachPercent;
        } else {
          differences.push({
            category: simitem,
            coinSelect: c.char[simitem],
            userSelect: this.selections[simitem],
          });
        }
      });
      let coin = Object.assign({
        similarity,
        differences,
      }, c);
      return coin;
    });
    this.simCoins = coins.sort((b, a) => a.similarity - b.similarity).slice(0, 1);
  }

  parseQuery() {
    this.urlParams = this.$route.fullPath;
    // arch
    let aa: number[] = this.$route.query.a ? JSON.parse(this.$route.query.a as string) : [];
    for (let i = 0; i < aa.length; i++) {
      const arch = this.archList.find(_ => _.id == aa[i]);
      if (arch && arch.categoryKey && arch.key) {
        // because ts complain: Type 'any' is not assignable to type 'never'
        // so change the statements
        // this.selections[arch.categoryKey] = arch.key as any;
        let obj: any = {};
        obj[arch.categoryKey] = arch.key;
        Object.assign(this.selections, obj);
      }
    }

    // eco
    let ea: string[] = this.$route.query.e ? JSON.parse(this.$route.query.e as string) : [];
    this.selections['incentive'] = [];
    this.selections['governance'] = [];
    this.selections['dapp'] = [];
    for (let i = 0; i < ea.length; i++) {
      const eco = bcdata.ecoList.find(_ => _.id == ea[i]);
      if (eco && eco.categoryKey && eco.key) {
        this.selections[eco.categoryKey].push(eco.key);
      }
    }

    // display mode
    this.displayMode = this.$route.query.mode ? this.$route.query.mode as DisplayMode : "standard";
  }

  setQuery() {
    var archarr: number[] = [];
    var ecoarr: string[] = [];
    Object.entries(this.selections).map((kvp, idx) => {
      if (Array.isArray(kvp[1])) {
        // eco
        for (var i = 0; i < kvp[1].length; i++) {
          let eco = this.ecoData[kvp[0]][kvp[1][i]];
          if (eco) {
            ecoarr.push(eco.id);
          }
        }
      } else {
        //arch
        let arch = this.archList.find(_ => _.key == kvp[1]);
        if (arch) {
          archarr.push(arch.id);
        }
      }
    });

    this.$router.replace({
      query: {
        a: JSON.stringify(archarr).replace(" ", ""),
        e: JSON.stringify(ecoarr).replace(" ", ""),
        mode: this.displayMode,
      }
    });

    this.urlParams = this.$route.fullPath;
  }
}
